import React from "react";
import { ClientClipProjection } from "./ViewModels/ClientClipProjection";
import "./PodcastClipAudioPlayer.css";
import { AudioPlayer } from "./CustomAudioPlayer/components/AudioPlayer";

function audioPlayerItself(clip: ClientClipProjection): JSX.Element {
  return (
    <div className="audio-player-itself-container">
      <AudioPlayer
        src={clip.audioUrl}
        startTime={clip.startTime}
        endTime={clip.endTime}
      />
    </div>
  );
}

function playedClipVisualization(clip: ClientClipProjection): JSX.Element {
  return (
    <div className="played-clip-visualization">
      <img
        src={clip.thumbnailImageUrl}
        alt="the clip thumbnail"
        className="played-clip-visualization-image"
      />
      <div className="played-clip-visualization-text">
        <div className="played-clip-visualization-title">
          {clip.description}
        </div>
        <small className="played-clip-visualization-subtitle">
          {Math.round(clip.durationInSeconds / 60)} minutes
        </small>
      </div>
    </div>
  );
}

export function PodcastClipAudioPlayer(
  clip: ClientClipProjection
): JSX.Element {
  // 2 components side by side: played clip visualization on the left, audio player on the right
  return (
    <div className="audio-player-container">
      {playedClipVisualization(clip)}
      {audioPlayerItself(clip)}
    </div>
  );
}
